import React from 'react'
import './articles.css'
const Compliance = () => {
  return (
    <div className='articlecontainer'>
        <header>
    <h1>Complying with Ongoing Legal and Tax Obligations for Your Business in Albania</h1>
</header>

<main>
    <div class="content-section">
        <h2>1. Submit Regular Tax Reports</h2>
        <p>Depending on your business type, you will be required to submit tax reports either monthly, quarterly, or annually. These reports keep the tax authorities informed about your business activities and ensure that your tax obligations are being met.</p>
        <div class="sub-heading">Key Tax Reports:</div>
        <ul>
            <li><strong>Monthly Tax Reports:</strong> Typically required for businesses that are VAT-registered or have employees. These reports cover taxes on income, VAT, and social contributions.</li>
            <li><strong>Quarterly Tax Reports:</strong> In some cases, businesses may be required to submit tax reports on a quarterly basis, depending on their revenue or industry.</li>
            <li><strong>Annual Tax Reports:</strong> All businesses must submit an annual tax return, summarizing their income, expenses, and tax liabilities for the year.</li>
        </ul>
        <div class="sub-heading">How to Submit Reports:</div>
        <ul>
            <li>Use the E-Tax Portal for online submission of tax reports, making the process more streamlined and efficient.</li>
            <li>It's important to keep up with deadlines, as failing to submit reports on time can result in fines or penalties.</li>
        </ul>
    </div>

    <div class="content-section">
        <h2>2. Pay Income Tax, VAT, and Social Contributions</h2>
        <p>After submitting your tax reports, the next responsibility is to make sure you pay your taxes and contributions on time. These payments ensure that your business complies with Albania’s tax laws and avoids legal complications.</p>
        <div class="sub-heading">Taxes You May Need to Pay:</div>
        <ul>
            <li><strong>Income Tax:</strong> This is typically paid on the profits your business generates. The rate can vary depending on the business structure (e.g., LLC, sole proprietorship).</li>
            <li><strong>Value-Added Tax (VAT):</strong> If your business is VAT-registered, you will need to pay VAT on your sales, with regular filings of VAT returns to the tax authorities.</li>
            <li><strong>Social Security and Health Contributions:</strong> Both the employer and employee contribute to social security and health insurance. Employers must deduct the employee’s portion and submit payments to the Social and Health Insurance Institute (ISSH).</li>
        </ul>
        <div class="sub-heading">Payment Deadlines:</div>
        <ul>
            <li>Monthly Social Contributions are due by the 20th of the following month.</li>
            <li>Income Tax and VAT Payments are generally due on the same schedule as your tax report submissions (monthly or quarterly).</li>
        </ul>
    </div>

    <div class="content-section">
        <h2>3. Renew Residence and Work Permits (If Applicable)</h2>
        <p>As a foreign entrepreneur, you may need to renew your residence and work permits to continue operating your business in Albania legally.</p>
        <div class="sub-heading">Work and Residence Permit Renewal:</div>
        <ul>
            <li><strong>Work Permits:</strong> If you are actively working in Albania as a foreign entrepreneur, you will need to ensure your work permit remains valid. Work permits in Albania are typically issued for one year and must be renewed before expiration.</li>
            <li><strong>Residence Permits:</strong> Similarly, if you are living in Albania while operating your business, ensure that your residence permit is valid. These permits are typically renewed annually or biannually, depending on your status.</li>
        </ul>
        <div class="sub-heading">How to Renew:</div>
        <ul>
            <li>Work and residence permits can be renewed through the Ministry of Interior or the National Employment Service. It is advisable to start the renewal process well before your permit expires to avoid any legal issues.</li>
        </ul>
    </div>

</main>



</div>
  )
}

export default Compliance